import { elements } from '#components/calendar/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'

const options = {
  childList: true,
  subtree: true
}

export default wrapper => {
  const list = one(`.${elements.resourcesList} ul`, wrapper)
  const openerAdd = one(`.${elements.resourcesOpenerAdd}`, wrapper)
  const openerEmpty = one(`.${elements.resourcesOpenerEmpty}`, wrapper)

  const { rsrcs } = scope(wrapper)

  queueMicrotask(async () => {
    for await (const { target } of mutations(list, options, removed(list))) {
      const rsrcList = all('[type="hidden"][name="new_rsrc[]"]', list)
      let rsrcListValues = []
      let availableRsrcs

      for (const rsrc of rsrcList) {
        const { value } = rsrc
        rsrcListValues.push(value)
      }

      availableRsrcs = rsrcs.filter(value => !rsrcListValues.includes(value))

      if (!availableRsrcs.length) {
        openerAdd.classList.add(utilities.modifiers.display.none)
        openerEmpty.classList.remove(utilities.modifiers.display.none)
      } else {
        openerAdd.classList.remove(utilities.modifiers.display.none)
        openerEmpty.classList.add(utilities.modifiers.display.none)
      }
    }
  })
}
